<template>
  <div ref="target" :style="{ minHeight: isIntersecting ? 'auto' : `${placeholderHeight}px` }">
    <slot v-if="isIntersecting"></slot>
    <div v-else class="d-flex justify-center align-center" :style="{ height: `${placeholderHeight}px` }">
      <v-progress-circular indeterminate color="grey"></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "LazyRender",
  props: {
    placeholderHeight: {
      type: Number,
      default: 450, // Passe dies an die ungefähre Höhe deiner Karten an
    },
  },
  data() {
    return {
      isIntersecting: false,
      observer: null,
    }
  },
  mounted() {
    // Erstellt den Observer, der die "onIntersect" Methode aufruft
    this.observer = new IntersectionObserver(
      ([entry]) => {
        // Wenn das Element sichtbar wird...
        if (entry.isIntersecting) {
          this.isIntersecting = true // ...setze die Variable auf true...
          this.observer.disconnect() // ...und beende die Beobachtung, da es erledigt ist.
        }
      },
      {
        rootMargin: "100px", // Optional: Beginnt mit dem Laden, 100px bevor das Element sichtbar wird
      }
    )
    // Starte die Beobachtung des <div>-Elements
    this.observer.observe(this.$refs.target)
  },
  beforeDestroy() {
    // Wichtig: Aufräumen, um Memory Leaks zu verhindern
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>
